import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  TabPosition,
  TabStripTabComponent,
} from '@progress/kendo-angular-layout';
import {
  FileInfo,
  SelectEvent,
  UploadComponent,
} from '@progress/kendo-angular-upload';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { GridColumnMap } from '~/front-models/gridColumnMap';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { AccountSummary } from '~/models/administration/account';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { CustomFieldSummary } from '~/models/modules/customField';
import { FileSummary } from '~/models/modules/file';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { NoteSummary } from '~/models/modules/note';
import { AccountsService } from '~/services/administration.ts/accounts';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { GDataService } from '~/services/GDataService';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { FilesService } from '~/services/modules/stocks/files';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { NotesService } from '~/services/modules/stocks/notes';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import {
  LayoutManagerService,
  PORTAL_DATA,
} from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { allowedFileTypes } from '~/shared/enums/allowedFileTypes';
import { fileSources } from '~/shared/enums/fileSources';
import { PageState } from '~/shared/enums/stock-files.enum';

@Component({
    selector: 'picture-form',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StocksPicturesUpsertComponent
  extends MultiSiteAwareComponent
  implements OnInit, OnDestroy, AfterContentChecked {
  _kendoTabStripPosition: TabPosition = 'left';
  uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
  uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _accountColumnsMap: GridColumnMap[] = [];
  _accounts: AccountSummary[];
  _selectedAccounts: any[] = [];
  _selectedAccountIds: any[] = [];
  _theme: string;
  _isNew: boolean;
  _form: FormGroup;
  _active: boolean;
  _listbarcodegenerator: Array<any> = [];
  _isAutoGeneratingNumber: boolean;
  _file: File;
  _imageStream: any;
  _invalidForm: boolean;
  _selectFile: boolean = false;
  _imageCode = new FormControl();
  model: FileSummary = null;
  _pageState: PageState;
  pageState = PageState;
  _isActiveImage: boolean = false;
  _addClassActive: boolean = false;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameFormValue: boolean = false;
  _selectedTabId: number;
  _editFormActive: boolean;
  _currentUser: UserSummary;
  _customFields: CustomFieldSummary[][] = [];
  _customFieldsValue: any;
  _selectedLabelId: number;
  _isRenameLabel: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _page = 'files';
  _permissionScope = 'files';
  _language = 'en';
  _gridFieldText: GridFieldTextSummary[];
  _customTabs: any;
  _selectedLabelObjectCode: any;

  _customFieldsDictionary: { [key: string]: string } = {};
  _orderingTabsForm: boolean = false;
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  okCloseSubscription: any = null;
  _deactivatedFieldsForm: boolean = false;
  _systemFields: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  _requiredFields: Array<any> = [];
  _requiredFieldNames: Array<any> = [];

  _deactivatedFieldsGridData: any[] = [];

  _notes: NoteSummary[];
  _note: string;
  _isEditNote: boolean = false;
  _index: number;

  _userNewDataTabs: Array<any> = [];
  _dataTabs: Array<any> = [];
  _gridFieldAuth: GridFieldAuthorization[];
  _dataTabsSelected: Array<any> = [];
  _isMandatory: boolean = false;
  _editableNote: any;
  _storagePath: string;
  _isEditForms: boolean = false;
  _isDocument: boolean = false;
  reactivate: boolean = false;
  reactivateItem: any;
  reloadlist: any;
  //Quraim
  _allowedFileTypes: allowedFileTypes[] = [allowedFileTypes.image];
  _fileSource: fileSources;
  _isDialiog: boolean;
  _dialogComponentName: string;
  _dialogModel: any;
  _filePath: string;

  // @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Image_Title')
  kendoBarcodeGenImageTitle: ElementRef;
  // @ViewChild('accountTab') accountTab: TabStripTabComponent;
  @ViewChild('Kendo_Image_Description_Input')
  KendoImageDescriptionInput: ElementRef;
  @ViewChild('Kendo_Image_Title_Input')
  KendoImageTitleInput: ElementRef;

  @ViewChild('kendo_uploader_wrapper') uploadWrapper: ElementRef;
  @ViewChild('kendo_uploader') upload: UploadComponent;

  constructor(
    private _layoutManager: LayoutManagerService,
    private _themeManager: ThemeManagerService,
    private _accountsService: AccountsService,
    private _filesService: FilesService,
    private _fb: FormBuilder,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _securityService: SecurityService,
    private _gridFields: GridFieldsService,
    private _customFieldsService: CustomFieldsService,
    private _notesService: NotesService,
    public cdRef: ChangeDetectorRef,
    private _sharedService: SharedService,
    private _dataService: GDataService
  ) {
    super();
    this._getdata();
    this._storagePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/';//environment.api.urls.enterpriseApi + '\\';

    if (!this._isNew && this.model) {
      for (
        let i = 0;
        this.model.fileAccounts && i < this.model.fileAccounts.length;
        i++
      ) {
        // this._selectedAccounts.push({
        //     siteId: this.model.fileAccounts[i].site?.id,
        //     accountId: this.model.fileAccounts[i].account.id
        //   });
        this._selectedAccounts.push(+this.model.fileAccounts[i].account.id);
      }
    }
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._layoutManager.applyOverly();
    this._currentUser = this._securityService.currentUser;

    this.loadCustomFields(this.model?.id?.toString());
    this.loadLabels();
    this._customFieldsService
      .getDeactivatedCustomFields('stock')

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(
          (x) => x.formTab.page === this._page
        );
      });
  }

  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  _getdata() {
    this.model =
      this._sharedService.model && this._sharedService.model.model
        ? this._sharedService.model.model
        : null;
    this._pageState =
      this._sharedService.model && this._sharedService.model.pageState
        ? this._sharedService.model.pageState
        : null;
    //Quraim
    this._fileSource =
      this._sharedService.model && this._sharedService.model.fileSource
        ? this._sharedService.model.fileSource :
        fileSources.pictures;
    this._active = true;
    //this._isDocument = this._sharedService.model?.isDocument;

    if (this._pageState === PageState.ADD && this.model) {
      this.model.id = null;
      this.model.name = null;
      this.model.title = null;
    }
    if (this._pageState == PageState.EDIT && this.model) {
      this._filePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + this.model.stream;
    }
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  ngOnInit() {
    this._isNew = this.model && this.model.type ? false : true;

    this._initForm();

    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        if (this.kendoBarcodeGenImageTitle !== undefined)
          this.kendoBarcodeGenImageTitle.nativeElement.focus();
      }, 500);
    }
    if (!this._currentUser.isEnterprise) {
      this._tabEnabled = true;
    }
    if (!this._isNew) {
      this.getNotes(this.model.id, this._page);
    }

    this.getFormTabs();
    this.getAuth();
    this.getSystemFields();
    this.setMandatoryFields();
  }
  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('stock')

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(
          (x) => x.formTab.page === this._page
        );
      });
    this._deactivatedFieldsForm = true;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }
  _reactivate(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService
          .reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true,
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  this.loadCustomFields(this.model?.id?.toString());
                  this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            this._deactivatedFieldsForm = false;
          });
        this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name,
    });
    this.loadCustomFields(this.model?.id?.toString());
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    } else {
      this._editFormActive = true;
      this._isCustomfieldsFormValue = true;
    }
  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = false;
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    this.loadCustomFields(this.model?.id?.toString());
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }

  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;

    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }

  _getAccounts = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  };
  _edit() {
    this._pageState = PageState.EDIT;
    // this.accountTab.selected = true;
    // this.accountTab.disabled = false;
  }
  _imagenameFocus() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this._isActiveImage = false;
        this._addClassActive = false;
        this.kendoBarcodeGenImageTitle.nativeElement.focus();
        this.KendoImageDescriptionInput?.nativeElement.blur();
        this.KendoImageTitleInput?.nativeElement.blur();
        let ImageNameGen = this.kendoBarcodeGenImageTitle;
        ImageNameGen?.nativeElement.classList.add('focusedInput');
        let ImageDescription = this.KendoImageDescriptionInput;
        ImageDescription?.nativeElement.classList.remove('focusedInput');
        let ImageTitle = this.KendoImageTitleInput;
        ImageTitle?.nativeElement.classList.remove('focusedInput');
      });
    }
  }
  _imagetitleFocus() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this._isActiveImage = false;
        this._addClassActive = false;
        this.KendoImageTitleInput?.nativeElement.focus();
        //this.kendoBarcodeGenImageTitle.nativeElement.blur();
        this.KendoImageDescriptionInput?.nativeElement.blur();
        let ImageNameGen = this.KendoImageTitleInput;
        ImageNameGen?.nativeElement.classList.add('focusedInput');

        let ImageDescription = this.KendoImageDescriptionInput;
        ImageDescription?.nativeElement.classList.remove('focusedInput');
        //let ImageBarCodeGen = this.kendoBarcodeGenImageTitle;
        //ImageBarCodeGen?.nativeElement.classList.remove('focusedInput');
      });
    }
  }

  _imagedescFocus() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this._isActiveImage = false;
        this._addClassActive = false;
        this.KendoImageDescriptionInput.nativeElement.focus();
        //this.kendoBarcodeGenImageTitle.nativeElement.blur();
        this.KendoImageTitleInput?.nativeElement.blur();
        let ImageDescription = this.KendoImageDescriptionInput;
        ImageDescription?.nativeElement.classList.add('focusedInput');
        let ImageNameGen = this.KendoImageTitleInput;
        ImageNameGen?.nativeElement.classList.remove('focusedInput');
        //let ImageBarCodeGen = this.kendoBarcodeGenImageTitle;
        //ImageBarCodeGen?.nativeElement.classList.remove('focusedInput');
      });
    }
  }
  _imagetitleSubmited() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this._isActiveImage = true;
        this.KendoImageTitleInput.nativeElement.blur();
        this._addClassActive = false;
        let ImageTitle = this.KendoImageTitleInput;
        ImageTitle?.nativeElement.classList.remove('focusedInput');
      }, 100);
    }
  }
  _imageDescriptionSubmited() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this._isActiveImage = true;
        this.KendoImageDescriptionInput.nativeElement.blur();
        this._addClassActive = false;
        let ImageDescription = this.KendoImageDescriptionInput;
        ImageDescription?.nativeElement.classList.remove('focusedInput');
      }, 100);
    }
  }
  _skipUnitTitle() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        let ImageTitle = this.KendoImageTitleInput;
        ImageTitle.nativeElement.classList.remove('focusedInput');
        this.KendoImageTitleInput.nativeElement.blur();
        this.KendoImageDescriptionInput.nativeElement.focus();
        let ImageDescription = this.KendoImageDescriptionInput;
        ImageDescription?.nativeElement.classList.add('focusedInput');
        this._isActiveImage = true;
      });
    }
  }
  _skipUnitName() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        let ImageDescription = this.KendoImageDescriptionInput;
        ImageDescription.nativeElement.classList.remove('focusedInput');
        this.KendoImageDescriptionInput.nativeElement.blur();
        this._isActiveImage = true;
      });
    }
  }

  _barcodeSubmited() {
    this._imageCode.setValue(this._form.get('name').value);
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.KendoImageDescriptionInput.nativeElement.focus();
      }, 100);
    }
  }
  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }
  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter).subscribe((data: any) => {
      this._imageCode.setValue(data.result.toString());
      this._form.patchValue({
        name: data.result.toString(),
      });
      if (this._pageState == PageState.ADD) {
        setTimeout(() => {
          this.KendoImageTitleInput.nativeElement.focus();
          let ImageDescription = this.KendoImageTitleInput;
          ImageDescription.nativeElement.classList.add('focusedInput');
        }, 100);
      }
    });
  }
  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode('files', quantity);
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    } else {
      this._layoutManager.applyOverly();
    }
  }

  // _onTabSelect(e: any) {
  //     this._mobileMenuToggle();
  // }

  // _mobileMenuToggle() {
  //     let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
  //     mobiletabstrip.classList.toggle('visibletab');
  // }

  _onUploadClick() {
    let kendoUploader = this.uploadWrapper.nativeElement.querySelector('input');
    kendoUploader.click();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    console.warn(event);
    this._innerWidth = window.innerWidth;
    console.warn('window resize:' + this._innerWidth);
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }

  _onSave(e: any) {
    this.submit(e);
  }

  // _onEditForm() { }

  _onCancel() {
    if (this.model.id)
      this._closeForm(this.DataSaved);
    else
      this._closeForm();
  }

  // _closeFormXXX(fileId : number = null) {
  //     var closeComponent = {
  //       component : 'files',
  //       response : fileId,
  //       isClosed : true
  //     }
  //     this._active = false;
  //     this._gridLayoutManagerService.setGridDataSubjects('files');
  //     this.ngOnDestroy();
  //     this._sharedService.closeDialog.emit(closeComponent);
  //     this._sharedService.model = {};
  // }
  submodel: any
  _closeForm(listmodel: any = null) {
    if (!listmodel && this.DataSaved) {
      listmodel = this.DataSaved;
    }

    this.reloadlist = this._sharedService.model.reload;
    this.submodel = this._sharedService.model.submodel;
    var closeComponent = {
      component: 'files',
      isAttachment: true,
      isClosed: true,
      response: this.reloadlist === undefined ? null : listmodel,
      picObject: {
        file: listmodel?.fileElement,
        description: listmodel?.description,
        id: listmodel?.id,
        name: listmodel?.name,
        size: listmodel?.size,
        stream: listmodel?.stream,
        type: listmodel?.type,
        title: listmodel?.title
      },
    };

    this._active = false;
    //this._gridLayoutManagerService.setGridDataSubjects('files');
    this._layoutManager.setFromChanged('files');
    //this.ngOnDestroy();
    this._layoutManager.removeOverlay();
    this._filesService.filesFormClosed(this._form.get('name').value ?? '');
    this._sharedService.closeDialog.emit(closeComponent);
    //this._sharedService.closeDialog.emit(false);
    //Quraim
    this._dataService.push(closeComponent);
    if (this.submodel === null || this.submodel === '')
      this._sharedService.model = {};
  }

  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e);
  }

  _fileSelectedChanges(ev: SelectEvent) {
    ev.files.forEach((file: FileInfo) => {
      if (file.rawFile) {
        this._file = file.rawFile;
        const reader = new FileReader();
        reader.readAsDataURL(file.rawFile);

        reader.onloadend = () => {
          this._imageStream = reader.result;
          //Quraim
          if (!this.checkFileExtention()) {
            this._file = null;
            this._imageStream = null;
            this._form.patchValue({
              stream: null
            })
          }
        };
        if (this._pageState == PageState.ADD) {
          this._addClassActive = true;
        }
      }
    });
    this._selectFile = this._fileSelectedChanges.length > 0;
    this._isActiveImage = false;

  }

  private checkFileExtention(): boolean {
    let fileUploadedName = this._file.name;
    this._form.patchValue({
      name: this._file.name
    })
    const allowedExtensions =
      /* this._isDocument
        ? ['doc', 'docx', 'pdf', 'xls', 'xlsx', 'ppt', 'pptx'] : */
      ['png', 'jpeg', 'jpg', 'bmp'];
    const reg = /(?:\.([^.]+))?$/;
    const fileType = reg.exec(fileUploadedName)[1].toLowerCase();
    if (allowedExtensions.indexOf(fileType) == -1) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message:
          /* this._isDocument
            ? 'Only doc, docx, pdf, xls, xlsx, ppt and pptx extensions are allowed'
            :  */
          'Only PNG, JPG, JPEG and BMP extensions are allowed.',
        withoutConfirm: true,
      });

      setTimeout(() => {
        this.upload.clearFiles();
        this._file = null;
        this._imageStream = null;
      });

      return false;
    } else {
      return true;
    }
  }

  _fileRemoveEventHandler() {
    this._imageStream = null;
  }

  private _initForm() {
    this._form = this._fb.group({
      name: [this.model ? this.model.name : '', Validators.required],
      description: [
        this.model ? this.model.description : '', this.getLabel('LBL_PicDescription')?.isRequired ? Validators.required : null
      ],
      title: [
        this.model ? this.model.title : '', this.getLabel('LBL_PicPTitle')?.isRequired ? Validators.required : null
      ],
      stream: [this.model ? this.model.stream : null],
    });
  }
  _selectedimageSubmited() {
    this._isActiveImage = false;
    this._addClassActive = true;
  }
  DataSaved: any
  private submit = (e: string) => {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the Site for the desired Account.',
          withoutConfirm: true,
        });
        return;
      }
    }

    if (this._imageStream == null && this._isNew) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: this._isDocument
          ? 'Please select an document'
          : 'Please select an image.',
        withoutConfirm: true,
      });
    } else if (this._form.invalid && this._custominvalidForm) {
      this._invalidForm = true;
      this._invalidSubmit = true;
    } else if (this._form.invalid) {
      this._invalidForm = true;
    } else if (this._custominvalidForm) {
      this._invalidSubmit = true;
    } else {
      // work with custom fields
      if (this._customFieldsValue) {
        const entries = Object.entries(this._customFieldsValue);
        for (const [index, [key, value]] of entries.entries()) {
          this._customFieldsDictionary[key] = `${value}`;
        }
      }
      //
      this._invalidSubmit = false;
      this._invalidForm = false;
      const model = this._form.value;
      model['customFieldsValue'] = this._customFieldsDictionary;
      model['accountIds'] = this._selectedAccounts;
      //Quraim
      model.exension = this._pageState == PageState.ADD ? this._file.name.substring(this._file.name.lastIndexOf(".") + 1).toLowerCase() :
        this.model.stream?.substring(this.model.stream?.lastIndexOf(".") + 1).toLowerCase();
      model.typesToChecks = this._allowedFileTypes;
      model.fileSourceId = this._fileSource;
      // model.size = this.model.size;
      // model.type = this.model.type;
      //model.name = this._file.name;
      if (!this._isNew) {
        model.size = this.model.size;
        model.type = this.model.type;
        model.thumbnail = this.model.thumbnail;

        if (this._imageStream) {
          model.stream = this._imageStream;
        } else {
          model.stream = this.model.thumbnailBase64;
        }
        // model.stream = this.model.thumbnailBase64;
        // model.stream = this.model.stream;


        //model.stream = null;

        this._filesService.updateFile(this.model.id, model).subscribe((response: any) => {
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true,
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                model.id = response.responseId || this.model?.id;
                model.fileElement = response.extraData || (this.model as any)?.fileElement;
                if (this.model) {
                  if (response['extraData']?.name) { this.model.name = response['extraData'].name; }
                  if (response['extraData']?.stream) { this.model.stream = response['extraData'].stream; }
                }
                if (e === 'saveAndClose') {
                  this._closeForm(model);
                }
                else if (e === 'saveAndNew') {
                  this.resetFormState();
                }
                else if (e === 'save') {
                  this._pageState = PageState.EDIT;
                  if (this.model?.stream) {
                    this._filePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + this.model.stream;
                  }
                }
                this.DataSaved = model;
              }
              else {
                return;
              }
            }
          }
        });
      } else {
        model.size = this._file.size;
        model.type = this._file.type;
        model.stream = this._imageStream;

        this._filesService.createFile(model).subscribe((response: any) => {
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true,
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                model.id = response.responseId;
                model.fileElement = response.extraData;
                if (e === 'saveAndClose') {
                  this._closeForm(model);
                }
                else if (e === 'saveAndNew') {
                  this.resetFormState();
                }
                else if (e === 'save') {
                  this._pageState = PageState.EDIT;
                  this._isNew = false;
                  if (!this.model) {
                    this.model = <any>{};
                  }
                  this.model.id = response['extraData']?.id || response.responseId;
                  this.model.stream = response['extraData']?.stream;
                  this.model.name = response['extraData']?.name || model.name || this._file?.name;
                  this.model.title = response['extraData']?.title || model.title;
                  this.model.description = response['extraData']?.description || model.description;
                  this.model.size = response['extraData']?.size || this._file?.size;
                  this.model.type = response['extraData']?.type || this._file?.type;
                  this.model.thumbnailBase64 = response['extraData']?.thumbnailBase64 || response['extraData']?.thumbnail;
                  (this.model as any).fileElement = response['extraData'];
                  if (this.model.stream) {
                    this._filePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + this.model.stream;
                  }
                }
                this.DataSaved = model;
              }
              else {
                return;
              }
            }
          }
        });
      }
    }
  };

  private resetFormState() {
    this.model = null;
    this._file = null;
    this._imageStream = null;
    this._filePath = null;
    this._selectFile = false;
    this._isActiveImage = false;
    this._addClassActive = false;
    this.DataSaved = null;
    this._isNew = true;
    this._pageState = PageState.ADD;
    this._initForm();
    this._form.reset();
    if (this.upload) {
      this.upload.clearFiles();
    }
  }
  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
    this._initForm();
  }

  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    Object.keys(customFieldsValue).forEach((key) => {
      if (customFieldsValue[key] == null || customFieldsValue[key] == 'null') {
        customFieldsValue[key] = '';
      }
      if (
        this._customFields[tabId].find((x) => x.name == key).entityId ==
        undefined
      ) {
        //new mode, custom field data not added yet
        this._customFields[tabId].find((x) => x.name == key).entityId = -1;
        this._customFields[tabId]
          .find((x) => x.name == key)
          .customFieldsData.push({
            id: -1,
            value: 'null',
            entityId: -1,
            customFieldId: -1,
          });
      }
      var customFieldData = this._customFields[tabId]
        .find((x) => x.name == key)
        .customFieldsData.find(
          (x) =>
            x.entityId ==
            this._customFields[tabId].find((x) => x.name == key).entityId
        );
      if (customFieldData != undefined) {
        customFieldData.value = customFieldsValue[key];
      }
    });
    this._customFieldsValue = customFieldsValue;
  }

  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (
          this._customFields[i].findIndex((x) => x.id == customFieldId) != -1
        ) {
          this._customFields[i] = this._customFields[i].filter(
            (x) => x.id != customFieldId
          );
          return;
        }
      }
    }
  }

  _deactivateTab(tabId: number, page: string) {
    let model: any = {
      customFieldEntityId: page == 'files' ? 1 : 2,
      page: this._page,
      accountIds: this._selectedAccountIds,
    };
    this._customFieldsService
      .deleteCustomTab(tabId, model)

      .subscribe((response: any) => {
        if (response != null && response['message'] != null) {
          this._customFieldsService
            .getFormTabsByPage(this._page)

            .subscribe((data: any) => {
              //get custom tabs first
              this._customTabs = data.filter(
                (x: { isCustom: boolean }) => x.isCustom == true
              );
            });
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true,
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              // this._closeForm();
            } else {
              return;
            }
          }
        }
        //   this._closeForm();
      });
  }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }

  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }

  private loadCustomFields(entityId?: string) {
    this._customFieldsService
      .getCustomFields('stock', this._page, entityId)

      .subscribe((data) => {
        if (this.model != null && this.model.id != null) {
          let that = this;
          data.map(function (x) {
            x.entityId = that.model.id;
          });
        }
        var tabIds = data
          .map((item) => item.formTab?.id)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(
          data,
          (item: { tabId: any }) => item.tabId
        );
        let that = this;
        tabIds.forEach(function (tabId) {
          that._customFields[tabId] = grouped.get(tabId);
        });
      });

    this._customFieldsService
      .getFormTabsByPage(this._page)

      .subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter(
          (x: { isCustom: boolean }) => x.isCustom == true
        );
      });
  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  private loadLabels() {
    type NewType = GridFieldTextSummary;

    this._gridFields
      .getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: NewType[]) => {
        this._gridFieldText = data;
        this._initForm();
      });
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (
        this._gridFieldText.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        )
      )
        var result = this._gridFieldText.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        );
      else result = null;

      return result ? result : null;
    }
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }

  getNotes(fileId: number, page: string) {
    this._notesService
      .getNotesByPage(fileId, page)

      .subscribe((x: NoteSummary[]) => {
        this._notes = x;
      });
  }

  createNote() {
    let model = {
      description: this._note,
      pageName: this._page,
      fileId: this.model.id,
    };
    this._notesService
      .createNote(model)

      .subscribe((x: any) => {
        this._note = '';
        this.getNotes(this.model.id, this._page);
      });
  }

  editNote() {
    let model = {
      id: this._editableNote.id,
      description: this._editableNote.description,
    };
    this._notesService
      .editNote(model)

      .subscribe((x: any) => {
        this._isEditNote = false;
        this.getNotes(this.model.id, this._page);
      });
  }

  editableNote(note: any) {
    this._editableNote = note;
  }

  processEditNote(i: number) {
    this._isEditNote = !this._isEditNote;
    this._index = i;
  }

  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find((x) => x.order == i + 1)) {
      this._userNewDataTabs.find(
        (x) => x === this._dataTabsSelected.find((x) => x.order == i + 1)
      ).order = this._dataTabsSelected.find((x) => x.name === e.name).order;
    }
    this._userNewDataTabs.find((obj) => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter((obj) => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields
      .updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
      });
  }

  getFormTabs() {
    this._gridFields
      .getformTabsByPage(this._page)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields
      .getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (
        this._gridFieldAuth.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        )
      )
        var result = this._gridFieldAuth.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        );
      else result = null;

      return result ? result : new GridFieldAuthorization();
    }
  }

  getSystemFields() {
    this._gridFields
      .getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      });
  }

  setMandatoryFields() {
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach((element) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
      });

      // let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
      // Array.from(tabElementList.children).forEach((child: any) => {
      //   if (this._requiredFieldNames.find(x=>x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page ))){
      //     child.classList.add("mendatoryTab")
      //   }
      // });
    }, 500);
  }

  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }
}
